import React from 'react';
import './PromptLibraryLayout.css';

const PromptLibraryLayout = ({ children }) => {
  return (
    <div className="prompt-library-layout">
      <div className="prompt-library-layout-content">
        {children}
      </div>
    </div>
  );
};

export default PromptLibraryLayout;
